<template>
  <div class="training">
    <div class="title">
      <div class="left">
        <i></i>
        <p>技术培训</p>
      </div>
      <router-link :to="$Router.training.path"
                   class="more"
                   tag="a"
                   rel="nofollow">更多>></router-link>
    </div>
    <div class="top">
      <div class="img">
        <img src="/static/index/img.png"
             alt="" />
      </div>
      <div class="text">
        <div class="texttitle">{{con.title}}</div>
        <div class="info" v-html="con.contents"></div>
      </div>
    </div>
  </div>
</template>

<script>
import service from './training.js'
export default {
  name: 'training',
  data () {
    return {
      id: 98,
      cate_id: '',
      con: {}
    }
  },
  created () {
    // console.log(service.getColumnId)
    console.log('1')
    service.getColumnId(this)
  }
}
</script>

<style lang="scss" scoped>
@import './training';
</style>



// WEBPACK FOOTER //
// src/components/index/training/training.vue